import moment from 'moment'
import { parseDateTime } from './delivery'
import { COUNTRY_OPTIONS } from 'constants/delivery'
import { isInvalidPlace } from 'utils/validators/googlePlace'

const in2Hour = moment()
  .minute(Math.ceil(moment().minute() / 30) * 30)
  .add(2, 'hour')
  .format('HH:mm')

const initialWaypoint = {
  date: new Date(),
  schedule: false,
  fromTime: in2Hour,
  untilTime: in2Hour,
  estimatedHandlingDuration: '0',
}

export function parseCountry(countryName) {
  if (!countryName) {
    return { value: 'fr', label: 'FRA' }
  }
  const selectedCountry = COUNTRY_OPTIONS.find((country) => country.name === countryName)
  return selectedCountry
}

export function decorateDeliveryFavouriteEntity(entity) {
  return {
    ...entity,
    options: entity.options.reduce((previous, key) => ({ ...previous, [key]: true }), {}),
    transportRules: entity.transportRules.reduce((previous, key) => ({ ...previous, [key]: true }), {}),
    ...(entity.freightForwarders && {
      freightForwarders: entity.freightForwarders.map((item) => ({
        label: `${item.firstname} ${item.lastname} - ${item.managedCompany ? item.managedCompany.name : ''}`,
        value: item['@id'],
      })),
    }),
    receiptWaypoints: entity.receiptWaypoints.map((entity) => ({
      address: entity.address,
      additionalAddress: entity.additionalAddress,
      country: parseCountry(entity.country),
      googlePlaceId: entity.googlePlaceId,
      ...initialWaypoint,
    })),
    pickupWaypoints: entity.pickupWaypoints.map((entity) => ({
      address: entity.address,
      additionalAddress: entity.additionalAddress,
      country: parseCountry(entity.country),
      googlePlaceId: entity.googlePlaceId,
      ...initialWaypoint,
    })),
  }
}

export function parseDeliveryFavouritePayload(payload, values = []) {
  return {
    template: payload.id,
    ...(values.includes('merchandise') && {
      merchandise: payload.merchandise.map(({ quantity, ...merchandise }) => ({
        ...merchandise,
        width: parseInt(merchandise.width),
        height: parseInt(merchandise.height),
        depth: parseInt(merchandise.depth),
        weight: parseFloat(merchandise.weight),
        ...(merchandise.type !== 'bulk' ? { quantity: parseInt(quantity) } : {}),
      })),
    }),
    ...(values.includes('transportRules') && {
      transportRules: Object.keys(payload.transportRules || {}).filter((key) => payload.transportRules[key] === true),
    }),
    ...(payload.confirmation && {
      confirmation: payload.confirmation,
    }),
    ...(values.includes('options') && {
      options: Object.keys(payload.options || {}).filter((key) => payload.options[key] === true),
    }),
    receiptComment: payload.receiptComment,
    pickupWaypoints: payload.pickupWaypoints.map(
      ({
        date,
        fromTime,
        untilTime,
        address,
        additionalAddress,
        contactName,
        schedule,
        googlePlaceId,
        ...pickupWaypoint
      }) => ({
        additionalAddress,
        address,
        schedule: schedule ? 'asap' : 'between',
        fromDatetime: parseDateTime(date, fromTime),
        untilDatetime: parseDateTime(date, untilTime),
        estimatedHandlingDuration: parseInt(pickupWaypoint.estimatedHandlingDuration) * 60,
        contactName,
        googlePlaceId: !isInvalidPlace(googlePlaceId) ? googlePlaceId : undefined,
      }),
    ),
    receiptWaypoints: payload.receiptWaypoints.map(
      ({
        date,
        fromTime,
        untilTime,
        address,
        additionalAddress,
        contactName,
        schedule,
        googlePlaceId,
        ...receiptWaypoint
      }) => ({
        address,
        additionalAddress,
        schedule: schedule ? 'asap' : 'between',
        fromDatetime: parseDateTime(date, fromTime),
        untilDatetime: parseDateTime(date, untilTime),
        estimatedHandlingDuration: parseInt(receiptWaypoint.estimatedHandlingDuration) * 60,
        contactName,
        googlePlaceId: !isInvalidPlace(googlePlaceId) ? googlePlaceId : undefined,
      }),
    ),
  }
}
